import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const DownloadData = ({
  isOpen,
  onClose,
  onDownload,
  availableToxins,
  defaultStart,
  defaultEnd
}) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(defaultStart || "");
  const [endDate, setEndDate] = useState(defaultEnd || "");
  const [selectedToxin, setSelectedToxin] = useState("");
  const [format, setFormat] = useState("csv");

  const handleDownload = () => {
    onDownload({ startDate, endDate, selectedToxin, format });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
      <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-lg relative">
        <h2 className="text-xl font-semibold mb-4">{t("download.title")}</h2>

        <label className="block mb-2 text-sm font-medium">{t("download.start_date")}:</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="w-full border px-3 py-2 mb-4 rounded"
        />

        <label className="block mb-2 text-sm font-medium">{t("download.end_date")}:</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="w-full border px-3 py-2 mb-4 rounded"
        />

        <label className="block mb-2 text-sm font-medium">{t("download.toxin")}:</label>
        <select
          value={selectedToxin}
          onChange={(e) => setSelectedToxin(e.target.value)}
          className="w-full border px-3 py-2 mb-4 rounded"
        >
          <option value="">{t("download.all")}</option>
          {availableToxins.map((toxin) => (
            <option key={toxin} value={toxin}>{toxin}</option>
          ))}
        </select>

        <fieldset className="mb-4">
          <legend className="block mb-2 text-sm font-medium">{t("download.format")}:</legend>
          <label className="mr-4">
            <input
              type="radio"
              value="csv"
              checked={format === "csv"}
              onChange={() => setFormat("csv")}
              className="mr-1"
            />
            CSV
          </label>
          <label>
            <input
              type="radio"
              value="json"
              checked={format === "json"}
              onChange={() => setFormat("json")}
              className="mr-1"
            />
            JSON
          </label>
        </fieldset>

        <div className="flex justify-end space-x-3">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">
            {t("download.cancel")}
          </button>
          <button onClick={handleDownload} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
            {t("download.download")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadData;
